import { RGBA, getIntermediateColor } from './color';
import { isBetween } from './math';

export default function drawLifeBar(params: {
  width: number,
  height: number,
  x: number,
  y: number,
  startColor?: RGBA,
  endColor?: RGBA,
  lineColor?: RGBA,
  ratio: number,
  context: CanvasRenderingContext2D,
  reversed?: boolean
}): void
{
  const {
    width,
    height,
    x,
    y,
    startColor = {R: 0, G: 255, B: 0, A: 1} as RGBA,
    endColor = {R: 255, G: 0, B: 0, A: 1} as RGBA,
    lineColor,
    ratio,
    context,
    reversed
  } = params;

  let fillX = x;
  if (reversed)
    fillX = (width - width * ratio + x);

  if(!isBetween(ratio, 0, 1))
    return;

  const color = getIntermediateColor({
    startColor,
    endColor,
    ratio,
  });

  const lineColorString = (lineColor)
    ? RGBA.toString(lineColor)
    : RGBA.toString(color)
  ;

  context.fillStyle = RGBA.toString(color);
  context.strokeStyle = lineColorString;
  context.lineWidth = 1;
  context.fillRect(fillX, y, width * ratio, height);
  context.strokeRect(x, y, width, height);
  return;
}